var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatsUp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 11,
    fill: "#D5F7DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9V11.5L16.6295 10.1295L15.5 9H18Z",
    fill: "#07AF25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 15L10.0667 10.3846L12.4 13.6154L16.6295 10.1295M16.6295 10.1295L18 9M16.6295 10.1295L18 11.5V9M16.6295 10.1295L15.5 9H18",
    stroke: "#07AF25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsUp);
export default __webpack_public_path__ + "static/media/stats-up.92da7fb88009d2294d27defca4b0bfaf.svg";
export { ForwardRef as ReactComponent };